import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from "../Tabs/Tabs";
import RoomPresenterTabContent from "./RoomPresenterTabContent";

class RoomPresenter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active_tab: "general",
      room: this.props.room ? this.props.room : {},
      connected_rooms: this.props.connected_rooms
        ? this.props.connected_rooms
        : [],
      history_endpoint: this.props.history_endpoint
        ? this.props.history_endpoint
        : "",
      housekeeping_endpoint: this.props.housekeeping_endpoint
        ? this.props.housekeeping_endpoint
        : "",
      time_format: this.props.time_format || null,
      date_format: this.props.date_format || null,
      historical_view: this.props.historical_view || null,
      housekeeping_view: this.props.housekeeping_view || null,
      ...this.props,
    };
    this.setActiveTab = this.setActiveTab.bind(this);
    this.onChangeRevertVersion = this.onChangeRevertVersion.bind(this);
  }

  componentDidMount() {
    var self = this;
    if (this.props.housekeeping_view == true) {
      $(window).on("roomSaved", function () {
        $.ajax({
          type: "POST",
          url: `/admin/rooms/${self.state.id}/data`,
        }).done((data) => {
          self.setState({ ...data });
        });
      });
    } else {
      $(window).on("roomSaved", function () {
        $.ajax({
          type: "POST",
          url: `/admin/rooms/${self.state.room.id}/data`,
        }).done((data) => {
          self.setState({ ...data });
        });
      });
    }
  }

  render() {
    // console.log(this.props)
    var buttons = [
      {
        name: I18n.t("ok"),
        html_attributes: ['data-dismiss="modal"'],
      },
    ];
    return (
      <div className="RoomTypeBuilder">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <RoomPresenterTabContent {...this.state} />
        </div>
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  tabs() {
    if (this.props.housekeeping_view == true && this.props.historical_view == false) {
      return [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.setActiveTab,
        },
        {
          tabName: I18n.t("housekeeping"),
          targetName: "housekeeping",
          classes: this.state.active_tab === "housekeeping" ? "active" : null,
          changeHandler: this.setActiveTab,
        },
        {
          tabName: I18n.t("history"),
          targetName: "history",
          classes: this.state.active_tab === "history" ? "active" : null,
          changeHandler: this.setActiveTab,
        },
      ];
    } else if (this.props.historical_view == true) {
      return [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.setActiveTab,
        },
      ];
    } else {
      return [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.setActiveTab,
        },
        {
          tabName: I18n.t("room_types"),
          targetName: "room_types",
          classes: this.state.active_tab === "room_types" ? "active" : null,
          changeHandler: this.setActiveTab,
        },
        {
          tabName: I18n.t("connected_rooms"),
          targetName: "connected_rooms",
          classes:
            this.state.active_tab === "connected_rooms" ? "active" : null,
          changeHandler: this.setActiveTab,
        },
        {
          tabName: I18n.t("locks"),
          targetName: "locks",
          classes: this.state.active_tab === "locks" ? "active" : null,
          changeHandler: this.setActiveTab,
        },
        {
          tabName: I18n.t("history"),
          targetName: "history",
          classes: this.state.active_tab === "history" ? "active" : null,
          changeHandler: this.setActiveTab,
        },
      ];
    }
  }

  setActiveTab(tab) {
    this.setState({ active_tab: tab });
  }

  onChangeRevertVersion() {
    $.ajax({
      type: "POST",
      url: `/admin/rooms/${this.props.room.id}/version/${this.props.version.id}/revert`,
    }).done((data) => {
      window.parent.$(window.parent).trigger("roomSaved");
      this.setState({ loading: false });
      if (parent && parent.refresh_data) {
        parent.refresh_data(I18n.t("record_reverted_successfully"));
      }
      if (parent && parent.hide_modal) {
        parent.hide_modal();
      }
    });
  }
}
export default RoomPresenter;
